import {bp} from '../core/namespace.js';

$.extend(true, bp, {
  sharebuttons: (function () {
    $(document).ready(function () {
      $('.social-icon').click(function (e) {
        var clicked_element = $(this);
        e.preventDefault();
        window.open(clicked_element.attr('href'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        if (typeof ga === 'function') {
          ga('send', {
            'hitType': 'event',
            'eventCategory': 'estate_offer',
            'eventAction': 'share_' + clicked_element.data('network'),
            'eventLabel': clicked_element.data('pk'),
          });
        }
      });
    });
  })(),
});

export {bp};
